module.exports = __webpack_public_path__ + "img/red_exclamation.52acb720.svg";